
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    ArrayInput,
    SimpleFormIterator,
    NumberInput,
    AutocompleteInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput,
    ReferenceField,
    ImageField,
    BooleanField,
    BooleanInput,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/Home'
import ShortUrlField from '../Customs/ShortUrlField'
import MultipleField from '../Customs/MultipleField'
import MultipleInput from '../Customs/MultipleInput'
import DeleteAllButton from '../Customs/DeleteAllButton'
import ImportButton from '../Customs/ImportButton'
import ApiSelectInput from '../Customs/ApiSelectInput'
import DuplicateButton from '../Customs/DuplicateButton'
import MoveFormIterator from '../Customs/MoveFormIterator'
import GalleryInput from '../Customs/GalleryInput'

export const ShoppageIcon = BookIcon


const Shoppage_Filter = (props) => (
    <Filter {...props}>
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const ShoppageList = (props) => (
    <List {...props} filters={<Shoppage_Filter />} actions={<ListActions />} perPage={10}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.id : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="id" sortable={true} />
                    <ReferenceField source="website" reference="Website" >
                        <TextField source="ndd" />
                    </ReferenceField>

                    <EditButton />
                    <ShowButton />
                    <DuplicateButton tranformFields={[]} />
                </Datagrid>
            }
        />
    </List>
)

export const ShoppageShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="content" />
            <ArrayField source="content.hero">
                <Datagrid>
                    <TextField source="title" />
                    <ImageField source="media_url" />
                    <TextField source="path" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="content.bannerCarouselBlock">
                <Datagrid>
                    <TextField source="title" />
                    <ImageField source="media_url" />
                    <TextField source="path" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="content.subCarouselBlock">
                <Datagrid>
                    <TextField source="title" />
                    <ImageField source="media_url" />
                    <TextField source="path" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="content.products">
                <Datagrid>
                    <ReferenceField source="product" reference="Product">
                        <TextField source="title" />
                    </ReferenceField>
                </Datagrid>
            </ArrayField>
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>

export const ShoppageEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <ArrayInput source="content.hero">
                <MoveFormIterator>
                    <TextInput source="title" />
                    <GalleryInput source="media" optionText="s3_key" />
                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.bannerCarouselBlock">
                <MoveFormIterator>
                    <TextInput source="title" />
                    <GalleryInput source="media" optionText="s3_key" />
                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.subCarouselBlock">
                <MoveFormIterator>
                    <TextInput source="title" validate={required()} />
                    <GalleryInput source="media" optionText="s3_key" />
                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" validate={required()} />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.products">
                <MoveFormIterator>
                    <ReferenceInput source="product" reference="Product" validate={required()} perPage={10000} style={{ width: "800px" }} >
                        <AutocompleteInput optionText="title" style={{ width: "800px" }} />
                    </ReferenceInput>
                </MoveFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Edit>
)

export const ShoppageCreate = (props) => (
    <Create {...props} >
        <SimpleForm redirect="show">
            <ArrayInput source="content.hero">
                <MoveFormIterator>
                    <TextInput source="title" />
                    <GalleryInput source="media" optionText="s3_key" />

                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.bannerCarouselBlock">
                <MoveFormIterator>
                    <TextInput source="title" />
                    <GalleryInput source="media" optionText="s3_key" />

                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.subCarouselBlock">
                <MoveFormIterator>
                    <TextInput source="title" validate={required()} />
                    <GalleryInput source="media" optionText="s3_key" />

                    {/* <ReferenceInput source="media" reference="Media" validate={required()} perPage={10000} >
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                    <TextInput source="path" validate={required()} />
                </MoveFormIterator>
            </ArrayInput>
            <ArrayInput source="content.products">
                <MoveFormIterator>
                    <ReferenceInput source="product" reference="Product" validate={required()} perPage={10000} style={{ width: "800px" }} >
                        <AutocompleteInput optionText="title" style={{ width: "800px" }} />
                    </ReferenceInput>
                </MoveFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
)
